import { Component, input, output } from '@angular/core';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';

@Component({
    selector: 'pp-new-dashlet-modal-value-breakdown-fields-custom-field-picker',
    templateUrl: './new-dashlet-modal-value-breakdown-fields-custom-field-picker.component.html',
    styleUrl: './new-dashlet-modal-value-breakdown-fields-custom-field-picker.component.scss',
    standalone: false
})
export class NewDashletModalValueBreakdownFieldsCustomFieldPickerComponent {
  ppListFieldId = input<string>();
  ppNumericalFieldId = input<string>();
  ppListFieldIdChange = output<string>();
  ppNumericalFieldIdChange = output<string>();
  ppWorkspaceId = input<string>();

  EIconPath = EIconPath;
}
